
// Question score calculation utilities

import { FormOption } from '../types/api';

// Utility functions for score and SWOT calculations

export const getScoreColor = (earnedPoints: number, totalPoints: number): string => {
  if (totalPoints === 0) return 'theme-warning';
  const percentage = (earnedPoints / totalPoints) * 100;
  
  if (percentage === 100) return 'theme-success';
  if (percentage === 0) return 'theme-danger';
  return 'theme-warning';
};

export interface SWOTCounts {
  strength: number;
  weakness: number;
  opportunity: number;
  threat: number;
}

export const getSWOTCounts = (swotItems: Array<{ swot_type_id: number }>): SWOTCounts => {
  const counts: SWOTCounts = {
    strength: 0,
    weakness: 0,
    opportunity: 0,
    threat: 0
  };
  
  swotItems.forEach(item => {
    switch (item.swot_type_id) {
      case 1: counts.strength++; break;
      case 2: counts.weakness++; break;
      case 3: counts.opportunity++; break;
      case 4: counts.threat++; break;
    }
  });
  
  return counts;
};


/**
 * Get the appropriate score for an option based on reviewer override logic
 * @param option - The form option
 * @returns The score to use (reviewer_points if overridden, otherwise points)
 */
export const getOptionScore = (option: FormOption): number => {
  if (option.is_reviewer_points === 1 && option.reviewer_points !== null) {
    return option.reviewer_points; // Reviewer override score
  }
  return option.rated_points || 0; // System generated score
};

/**
 * Calculate total question score from selected options
 * @param options - Array of form options
 * @param selectedOptionIds - Object mapping option IDs to their selection state
 * @returns Total score of selected options
 */
export const calculateQuestionScore = (
  options: FormOption[], 
  selectedOptionIds: Record<number, boolean>
): number => {
  if (!options || options.length === 0) return 0;
  
  return options.reduce((total, option) => {
    if (selectedOptionIds[option.id]) {
      return total + getOptionScore(option);
    }
    return total;
  }, 0);
};
